const DEFAULT_ERROR_MESSAGE =
  "Não foi possível concluir a verificação. Tente novamente.";

export function createRecaptchaWidgetOptions({
  siteKey,
  onVerified,
  onExpired,
  onError,
}) {
  return {
    sitekey: siteKey,
    theme: "light",
    size: "normal",
    callback: onVerified,
    "expired-callback": onExpired,
    "error-callback": onError,
  };
}

export function handleRecaptchaError(
  context,
  message = DEFAULT_ERROR_MESSAGE,
) {
  context.statusMessage = message;
  context.hasError = true;
  context.$emit("error");
}

export async function retryRecaptcha(context) {
  context.hasError = false;
  context.statusMessage = "Carregando verificação de segurança...";

  if (context.recaptchaApi && context.widgetId !== null) {
    context.recaptchaApi.reset(context.widgetId);
    return;
  }

  await context.initialize();
}
